<nav id="main_navbar" class="navbar navbar-expand-xl rounded shadow-sm p-2">
  <button #navbarToggler class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"><i class='bx bx-menu bx-sm'></i></span>
  </button>
  <div #navbarCollapse class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="nav navbar m-auto">
      <ng-container *ngTemplateOutlet="recursiveMenu; context:{ $implicit: MenuFinal }">
      </ng-container>
    </ul>
  </div>
</nav>

<ng-template #recursiveMenu let-menus>
  @for (menu of menus; track menu.IdCategoria) {
    <li class="nav-item" (mouseenter)="onMenuItemHover($event, menu)">
      <!-- Desktop: Link con hover y chevron -->
      <a [routerLink]="categoryPath(menu)" 
         (click)="VentanaProductos(menu, $event)" 
         title="{{menu.Categoria}}" 
         class="nav-link desktop-link" 
         role="button"
         [attr.aria-haspopup]="menu.Hijos.length > 0 ? 'true' : 'false'"
         [attr.aria-expanded]="false">
        {{menu.Categoria}}
        @if (menu.Hijos.length > 0) {
          <i class='bx bx-chevron-down desktop-chevron'></i>
        }
      </a>

      <!-- Mobile: Link + Toggle separados -->
      <div class="mobile-menu-item">
        <a [routerLink]="categoryPath(menu)" 
           (click)="VentanaProductos(menu, $event)" 
           title="{{menu.Categoria}}" 
           class="nav-link mobile-link">
          {{menu.Categoria}}
        </a>
        @if (menu.Hijos.length > 0) {
          <button 
            class="mobile-toggle-btn" 
            (click)="toggleMobileSubmenu(menu, $event)"
            [class.active]="isMobileSubmenuOpen(menu.IdCategoria)"
            type="button">
            <i class='bx' [class.bx-chevron-down]="!isMobileSubmenuOpen(menu.IdCategoria)" 
                          [class.bx-chevron-up]="isMobileSubmenuOpen(menu.IdCategoria)"></i>
          </button>
        }
      </div>

      @if (menu.Hijos.length > 0) {
        <ul id="nav{{menu.IdCategoria}}" 
            class="shadow-sm navLastchild" 
            [class.mobile-open]="isMobileSubmenuOpen(menu.IdCategoria)"
            [class.mobile-closed]="!isMobileSubmenuOpen(menu.IdCategoria)"
            #submenu>
          <ng-container *ngTemplateOutlet="recursiveMenu; context:{ $implicit: menu.Hijos }"></ng-container>
        </ul>
      }
    </li>
  }
</ng-template>
